import React from 'react';

const getSize = (size) => {
  switch (size) {
    case 'small':
      return 'c-btn--small';
    default:
      return '';
  }
};

const getStyleType = (style) => {
  switch (style) {
    case 'secondary':
      return 'c-btn--secondary';
    case 'outline':
      return 'c-btn-outline';
    case 'search':
      return 'c-btn--search';
    case 'close':
      return 'c-btn--close';
    case 'simple':
      return 'c-btn-simple--secondary';
    case 'edit':
      return 'c-btn--edit c-btn--effect';
    case 'edit-icon':
      return 'c-btn--edit-icon-only';
    case 'update':
      return 'c-btn--update';
    case 'delete':
      return 'c-btn--delete';
    case 'tertiary':
      return 'c-btn--tertiary';
    case 'thumbsup':
      return 'c-btn--thumbsup';
    case 'clap':
      return 'c-btn--clap';
    case 'primary':
    default:
      return 'c-btn--primary';
  }
};

const Button = ({ children, size, styleType, className = '', ...others }) => (
  <button
    className={`c-btn ${getSize(size)} ${getStyleType(styleType)} ${className}`}
    {...others}
  >
    {children}
  </button>
);

export default Button;



// WEBPACK FOOTER //
// ./src/common/Button.js